/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BadRequestErrorResponse,
    BadRequestErrorResponseFromJSON,
    BadRequestErrorResponseToJSON,
    ConflictErrorResponse,
    ConflictErrorResponseFromJSON,
    ConflictErrorResponseToJSON,
    DeleteFirmwaresRequest,
    DeleteFirmwaresRequestFromJSON,
    DeleteFirmwaresRequestToJSON,
    FirmwareDeploymentRequest,
    FirmwareDeploymentRequestFromJSON,
    FirmwareDeploymentRequestToJSON,
    FirmwareForRescueResponse,
    FirmwareForRescueResponseFromJSON,
    FirmwareForRescueResponseToJSON,
    FirmwareResponse,
    FirmwareResponseFromJSON,
    FirmwareResponseToJSON,
    FirmwareS3Request,
    FirmwareS3RequestFromJSON,
    FirmwareS3RequestToJSON,
    FirmwaresResponse,
    FirmwaresResponseFromJSON,
    FirmwaresResponseToJSON,
    NewResourceResponse,
    NewResourceResponseFromJSON,
    NewResourceResponseToJSON,
    NotFoundErrorResponse,
    NotFoundErrorResponseFromJSON,
    NotFoundErrorResponseToJSON,
} from '../models';

export interface CreateFirmwareRequest {
    enableInvalidation: boolean;
    file?: Blob;
}

export interface DeleteFirmwareRequest {
    id: string;
}

export interface DeleteFirmwaresOperationRequest {
    deleteFirmwaresRequest?: DeleteFirmwaresRequest;
}

export interface DeployFirmwareRequest {
    id: string;
    firmwareDeploymentRequest: FirmwareDeploymentRequest;
}

export interface DownloadFirmwareS3Request {
    enableInvalidation: boolean;
    firmwareS3Request: FirmwareS3Request;
}

export interface ReadFirmwareRequest {
    id: string;
}

export interface ReadFirmwaresRequest {
    filter?: string | null;
    offset?: number | null;
    limit?: number | null;
}

export interface ReadFirmwaresByDeviceTypeIdRequest {
    deviceTypeId: string;
    offset?: number | null;
    limit?: number | null;
}

export interface ReadFirmwaresForRescueRequest {
    deviceTypeId: string;
}

export interface UploadFirmwareWithUiFormRequest {
    enableInvalidation: boolean;
    firmwareBinary?: Blob;
    version?: string;
    type?: string;
    date?: string;
    deviceTypeIds?: string;
    client?: string;
    comment?: string;
    extraData?: string;
}

/**
 * 
 */
export class FirmwaresApi extends runtime.BaseAPI {

    /**
     * Create a new firmware.
     */
    async createFirmwareRaw(requestParameters: CreateFirmwareRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<NewResourceResponse>> {
        if (requestParameters.enableInvalidation === null || requestParameters.enableInvalidation === undefined) {
            throw new runtime.RequiredError('enableInvalidation','Required parameter requestParameters.enableInvalidation was null or undefined when calling createFirmware.');
        }

        const queryParameters: any = {};

        if (requestParameters.enableInvalidation !== undefined) {
            queryParameters['enableInvalidation'] = requestParameters.enableInvalidation;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/firmwares`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NewResourceResponseFromJSON(jsonValue));
    }

    /**
     * Create a new firmware.
     */
    async createFirmware(requestParameters: CreateFirmwareRequest, initOverrides?: RequestInit): Promise<NewResourceResponse> {
        const response = await this.createFirmwareRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete firmware by ID.
     */
    async deleteFirmwareRaw(requestParameters: DeleteFirmwareRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteFirmware.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/firmwares/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete firmware by ID.
     */
    async deleteFirmware(requestParameters: DeleteFirmwareRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteFirmwareRaw(requestParameters, initOverrides);
    }

    /**
     * Delete firmwares by IDs.
     */
    async deleteFirmwaresRaw(requestParameters: DeleteFirmwaresOperationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/firmwares`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteFirmwaresRequestToJSON(requestParameters.deleteFirmwaresRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete firmwares by IDs.
     */
    async deleteFirmwares(requestParameters: DeleteFirmwaresOperationRequest = {}, initOverrides?: RequestInit): Promise<void> {
        await this.deleteFirmwaresRaw(requestParameters, initOverrides);
    }

    /**
     * Deploy firmware.
     */
    async deployFirmwareRaw(requestParameters: DeployFirmwareRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deployFirmware.');
        }

        if (requestParameters.firmwareDeploymentRequest === null || requestParameters.firmwareDeploymentRequest === undefined) {
            throw new runtime.RequiredError('firmwareDeploymentRequest','Required parameter requestParameters.firmwareDeploymentRequest was null or undefined when calling deployFirmware.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/firmwares/{id}/deployment`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FirmwareDeploymentRequestToJSON(requestParameters.firmwareDeploymentRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deploy firmware.
     */
    async deployFirmware(requestParameters: DeployFirmwareRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deployFirmwareRaw(requestParameters, initOverrides);
    }

    /**
     * Download a firmware from S3
     */
    async downloadFirmwareS3Raw(requestParameters: DownloadFirmwareS3Request, initOverrides?: RequestInit): Promise<runtime.ApiResponse<NewResourceResponse>> {
        if (requestParameters.enableInvalidation === null || requestParameters.enableInvalidation === undefined) {
            throw new runtime.RequiredError('enableInvalidation','Required parameter requestParameters.enableInvalidation was null or undefined when calling downloadFirmwareS3.');
        }

        if (requestParameters.firmwareS3Request === null || requestParameters.firmwareS3Request === undefined) {
            throw new runtime.RequiredError('firmwareS3Request','Required parameter requestParameters.firmwareS3Request was null or undefined when calling downloadFirmwareS3.');
        }

        const queryParameters: any = {};

        if (requestParameters.enableInvalidation !== undefined) {
            queryParameters['enableInvalidation'] = requestParameters.enableInvalidation;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/firmwares/s3`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FirmwareS3RequestToJSON(requestParameters.firmwareS3Request),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NewResourceResponseFromJSON(jsonValue));
    }

    /**
     * Download a firmware from S3
     */
    async downloadFirmwareS3(requestParameters: DownloadFirmwareS3Request, initOverrides?: RequestInit): Promise<NewResourceResponse> {
        const response = await this.downloadFirmwareS3Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read firmware by ID.
     */
    async readFirmwareRaw(requestParameters: ReadFirmwareRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<FirmwareResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling readFirmware.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/firmwares/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FirmwareResponseFromJSON(jsonValue));
    }

    /**
     * Read firmware by ID.
     */
    async readFirmware(requestParameters: ReadFirmwareRequest, initOverrides?: RequestInit): Promise<FirmwareResponse> {
        const response = await this.readFirmwareRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read firmwares.
     */
    async readFirmwaresRaw(requestParameters: ReadFirmwaresRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<FirmwaresResponse>> {
        const queryParameters: any = {};

        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/firmwares`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FirmwaresResponseFromJSON(jsonValue));
    }

    /**
     * Read firmwares.
     */
    async readFirmwares(requestParameters: ReadFirmwaresRequest = {}, initOverrides?: RequestInit): Promise<FirmwaresResponse> {
        const response = await this.readFirmwaresRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read firmwares by device type id.
     */
    async readFirmwaresByDeviceTypeIdRaw(requestParameters: ReadFirmwaresByDeviceTypeIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<FirmwaresResponse>> {
        if (requestParameters.deviceTypeId === null || requestParameters.deviceTypeId === undefined) {
            throw new runtime.RequiredError('deviceTypeId','Required parameter requestParameters.deviceTypeId was null or undefined when calling readFirmwaresByDeviceTypeId.');
        }

        const queryParameters: any = {};

        if (requestParameters.deviceTypeId !== undefined) {
            queryParameters['deviceTypeId'] = requestParameters.deviceTypeId;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/firmwaresByDeviceTypeId`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FirmwaresResponseFromJSON(jsonValue));
    }

    /**
     * Read firmwares by device type id.
     */
    async readFirmwaresByDeviceTypeId(requestParameters: ReadFirmwaresByDeviceTypeIdRequest, initOverrides?: RequestInit): Promise<FirmwaresResponse> {
        const response = await this.readFirmwaresByDeviceTypeIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read firmwares avaliable for rescue by deviceType ID.
     */
    async readFirmwaresForRescueRaw(requestParameters: ReadFirmwaresForRescueRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<{ [key: string]: Array<FirmwareForRescueResponse>; }>> {
        if (requestParameters.deviceTypeId === null || requestParameters.deviceTypeId === undefined) {
            throw new runtime.RequiredError('deviceTypeId','Required parameter requestParameters.deviceTypeId was null or undefined when calling readFirmwaresForRescue.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/firmwares/forRescue/{deviceTypeId}`.replace(`{${"deviceTypeId"}}`, encodeURIComponent(String(requestParameters.deviceTypeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Read firmwares avaliable for rescue by deviceType ID.
     */
    async readFirmwaresForRescue(requestParameters: ReadFirmwaresForRescueRequest, initOverrides?: RequestInit): Promise<{ [key: string]: Array<FirmwareForRescueResponse>; }> {
        const response = await this.readFirmwaresForRescueRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read unused firmware.
     */
    async readUnusedFirmwareRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<FirmwaresResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/firmwares/unused`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FirmwaresResponseFromJSON(jsonValue));
    }

    /**
     * Read unused firmware.
     */
    async readUnusedFirmware(initOverrides?: RequestInit): Promise<FirmwaresResponse> {
        const response = await this.readUnusedFirmwareRaw(initOverrides);
        return await response.value();
    }

    /**
     * Upload firmware description and .bin file
     */
    async uploadFirmwareWithUiFormRaw(requestParameters: UploadFirmwareWithUiFormRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<NewResourceResponse>> {
        if (requestParameters.enableInvalidation === null || requestParameters.enableInvalidation === undefined) {
            throw new runtime.RequiredError('enableInvalidation','Required parameter requestParameters.enableInvalidation was null or undefined when calling uploadFirmwareWithUiForm.');
        }

        const queryParameters: any = {};

        if (requestParameters.enableInvalidation !== undefined) {
            queryParameters['enableInvalidation'] = requestParameters.enableInvalidation;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.firmwareBinary !== undefined) {
            formParams.append('firmwareBinary', requestParameters.firmwareBinary as any);
        }

        if (requestParameters.version !== undefined) {
            formParams.append('version', requestParameters.version as any);
        }

        if (requestParameters.type !== undefined) {
            formParams.append('type', requestParameters.type as any);
        }

        if (requestParameters.date !== undefined) {
            formParams.append('date', requestParameters.date as any);
        }

        if (requestParameters.deviceTypeIds !== undefined) {
            formParams.append('deviceTypeIds', requestParameters.deviceTypeIds as any);
        }

        if (requestParameters.client !== undefined) {
            formParams.append('client', requestParameters.client as any);
        }

        if (requestParameters.comment !== undefined) {
            formParams.append('comment', requestParameters.comment as any);
        }

        if (requestParameters.extraData !== undefined) {
            formParams.append('extraData', requestParameters.extraData as any);
        }

        const response = await this.request({
            path: `/firmwares/form`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NewResourceResponseFromJSON(jsonValue));
    }

    /**
     * Upload firmware description and .bin file
     */
    async uploadFirmwareWithUiForm(requestParameters: UploadFirmwareWithUiFormRequest, initOverrides?: RequestInit): Promise<NewResourceResponse> {
        const response = await this.uploadFirmwareWithUiFormRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
